export const SEARCH_PARAM = "search";
export const FILTER_PARAM = "filter";
export const DURATION_PARAM = "duration";
